import { scheduleWork } from './Scheduler';
export function createNoopHandle() {
    return {
        cancel: function () { return null; },
        cancelAndRunNow: function () { return null; },
        adjustPriority: function () { return null; },
    };
}
export function createHandle(scheduledWork) {
    // Flag work as cancelled. It will be skipped when the scheduler tries to run this task.
    // If work was already completed, nothing will happen.
    var cancel = function () { return (scheduledWork.cancelled = true); };
    // Flags work as cancelled, but also run the work immediately. It also marks the work as completed.
    // If work was already completed, nothing will happen.
    var cancelAndRunNow = function () {
        // Work has already been cancelled, it cannot be run.
        if (scheduledWork.cancelled) {
            return;
        }
        cancel();
        if (!scheduledWork.completed) {
            scheduledWork.work();
            scheduledWork.completed = true;
        }
    };
    // Allows pending work to move up or down in priority. Is a noop for work that's already been run.
    var adjustPriority = function (targetPriority) {
        cancel();
        // if the work has already completed, adjust priority shouldn't do anything.
        if (scheduledWork.completed) {
            return createNoopHandle();
        }
        // re-schedule the work with the new priority.
        return scheduleWork(scheduledWork.work, targetPriority);
    };
    return {
        cancel: cancel,
        cancelAndRunNow: cancelAndRunNow,
        adjustPriority: adjustPriority,
    };
}
//# sourceMappingURL=Handles.js.map